import {
  ChangeDetectionStrategy,
  Component,
  inject,
  Injector,
  Input,
} from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { JournalSignerAddEditComponent } from '../journal-signer-add-edit/journal-signer-add-edit.component';
import { PresentationalAtomsModule } from '@et/presentational/atoms';

@Component({
  selector: 'et-journal-signer-card-wrapper',
  imports: [PresentationalAtomsModule],
  templateUrl: './journal-signer-card-wrapper.component.html',
  styleUrl: './journal-signer-card-wrapper.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class JournalSignerCardWrapperComponent {
  @Input({ required: true }) isFinalized!: boolean;
  @Input({ required: true }) noSigners!: boolean;
  @Input({ required: true }) isLoading!: boolean;

  private dialog = inject(MatDialog);
  private injector = inject(Injector);

  onAddSigner() {
    this.dialog.open(JournalSignerAddEditComponent, {
      injector: this.injector,
      panelClass: ['et-dialog-radius', 'et-dialog-padding'],
      autoFocus: false,
      width: '100%',
      maxWidth: '800px',
      maxHeight: '90vh',
    });
  }
}
